import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import type { VendorCtaSelectorProps } from './VendorCtaSelector';

const CustomCta = ({ ctaDetails, variant, vin }: VendorCtaSelectorProps) => {
  const {
    ctaVendorLink,
    ctaVendorTarget,
    ctaVendorButtonLabel,
    ctaVendorCustomId,
    ctaVendorAdditionalClasses,
    ctaVendorSeoAttributes,
  } = ctaDetails;
  return (
    <TextButton
      variant={variant}
      href={ctaVendorLink ?? '#'}
      target={ctaVendorTarget}
      key={`key_${ctaVendorButtonLabel}`}
      id={ctaVendorCustomId}
      className={ctaVendorAdditionalClasses}
      data-seo={ctaVendorSeoAttributes}
      data-vin={vin}
      data-testid="custom"
    >
      {ctaVendorButtonLabel}
    </TextButton>
  );
};

export default CustomCta;
